import { render } from "./ChatroomActions.vue.js?vue&type=template&id=82dc58c4&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatroomActions.vue?vue&type=template&id=82dc58c4&scoped=true"
import script from "./ChatroomActions.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatroomActions.vue?vue&type=script&lang=js"
export * from "./ChatroomActions.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatroomActions.vue?vue&type=script&lang=js"

import "./ChatroomActions.vue.scss?vue&type=style&index=0&id=82dc58c4&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatroomActions.vue?vue&type=style&index=0&id=82dc58c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82dc58c4"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/chat-room-page/ChatroomActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82dc58c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82dc58c4', __exports__)) {
    api.reload('82dc58c4', __exports__)
  }
  
  module.hot.accept("./ChatroomActions.vue.js?vue&type=template&id=82dc58c4&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatroomActions.vue?vue&type=template&id=82dc58c4&scoped=true", () => {
    api.rerender('82dc58c4', render)
  })

}


export default __exports__